import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

class BgCircleAnimation {
  constructor(element) {
    this.element = element;

    /**
     * Parent container holding bg circles
     */
    this.scrollContainer = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        toggleActions: 'restart complete restart reset',
      },
    });
  }

  init() {
    ScrollTrigger.defaults({
      toggleActions: 'restart pause resume pause',
    });

    /**
     * Add bg animations to master timeline
     */
    this.scrollContainer.add(this.addBgAnimation());
  }

  addBgAnimation() {
    const tl = gsap.timeline({id: 'bgCircles'});

    const circleElementNodes = this.element.querySelectorAll('[data-element="bg-circle"]');
    const circleElements = gsap.utils.toArray(circleElementNodes);

    const rectangleElementNodes = this.element.querySelectorAll('[data-element="bg-rectangle"]');
    const rectangleElements = gsap.utils.toArray(rectangleElementNodes);

    tl.from(
      rectangleElements,
      {
        duration: 1,
        ease: 'power3.inOut',
        translateX: '100%',
        stagger: {
          each: 0.25,
        },
      },
    ).from(
      circleElements, {
        autoAlpha: 0,
        duration: 0.5,
        ease: 'power3.inOut',
      },
      '-=0.2'
    );

    return tl;
  }
}

const bgCirclesAnimation = {
  init() {
    const bgCircles = document.querySelectorAll('[data-module="bg-circles-animation"]');

    if (bgCircles && bgCircles.length) {
      bgCircles.forEach((element) => {
        const animation = new BgCircleAnimation(element);
        animation.init();
      });
    }
  },
};

export default bgCirclesAnimation;
